/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Observable, ReplaySubject} from 'rxjs';

import {Injectable} from '@angular/core';
import {LocalStorageService} from 'ngx-webstorage';
import {TermsAndConditionsAgreementStatusModel} from '@well/domain';

@Injectable({
  providedIn: 'root'
})
export class TermsAndConditionsLocalStorageService {

  private termsAndConditionsAgreementLocalStorageKey = 'termsAndConditionsAgreement';
  private localStorageSaveEventSubject: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(private $localStorage: LocalStorageService) {}

  getLocalStorageSaveEventStatus(): Observable<boolean> {
    return this.localStorageSaveEventSubject.asObservable();
  }

  emitLocalStorageSaveEvent(status: boolean) {
    this.localStorageSaveEventSubject.next(status);
  }

  clear() {
    this.$localStorage.clear(this.termsAndConditionsAgreementLocalStorageKey);
  }

  retrieve(): TermsAndConditionsAgreementStatusModel {
    return this.$localStorage.retrieve(this.termsAndConditionsAgreementLocalStorageKey);
  }

  store(termsAndConditionsAgreementStatus: TermsAndConditionsAgreementStatusModel) {
    this.$localStorage.store(this.termsAndConditionsAgreementLocalStorageKey, termsAndConditionsAgreementStatus);
  }

  observe(): Observable<TermsAndConditionsAgreementStatusModel> {
    return this.$localStorage.observe(this.termsAndConditionsAgreementLocalStorageKey);
  }
}
